/**
 * jasenmaksulaskuri.js (2017)
 * -------------------
 *
 * - laskee maksun inputista
 * - validoi inputtia
 *
 */

(function($) {

  $.fn.isannointi_jasenmaksulaskuri = function() {

    var $container = $(this),
        $form = $(this).find('.form'),
        $input = $form.find('.value'),
        $result = $container.find('.result'),
        $btn = $container.find('.btn');

    if (!$result) {
      return;
    }

    /**
     * Catch form submit
     */

    function calculate_annual_fee() {
      var value = $input.val();

      var $registration_annual_income_input = $('.isannointi-annual-business-amount input');
      if($registration_annual_income_input.length) {
        $registration_annual_income_input.val(value);
      }

      if(value.length) {
        value = parseInt(value);
      } else {
        value = -1;
      }

      var result = -1;

      var date = new Date();
      var this_year = date.getFullYear();

      if(this_year === 2017) {

        // Year 2017

        if(value < 100000) {
          result = 350;
        } else if(value < 250000) {
          result = 350 + (value - 100000) * 0.004354;
        } else if(value < 500000) {
          result = 1003 + (value - 250000) * 0.002902;
        } else if(value < 1000000) {
          result = 1729 + (value - 500000) * 0.002176;
        } else if(value < 2000000) {
          result = 2817 + (value - 1000000) * 0.001451;
        } else if(value < 4000000) {
          result = 4268 + (value - 2000000) * 0.000897;
        } else if(value < 16000000) {
          result = 6062 + (value - 4000000) * 0.000436;
        } else if(value == 16000000) {
          result = 11293;
        } else if(value > 16000000) {
          result = 11293 + (value - 16000000) * 0.00029;
        }
      } else {

        // Year 2018-2024
        // if(value < 100000) {
        //   result = 364;
        // } else if(value < 250000) {
        //   result = 364 + (value - 100000) * 0.0046660;
        // } else if(value < 500000) {
        //   result = 1064 + (value - 250000) * 0.003109;
        // } else if(value < 1000000) {
        //   result = 1841 + (value - 500000) * 0.002332;
        // } else if(value < 2000000) {
        //   result = 3007 + (value - 1000000) * 0.001555;
        // } else if(value < 4000000) {
        //   result = 4562 + (value - 2000000) * 0.000962;
        // } else if(value < 16000000) {
        //   result = 6486 + (value - 4000000) * 0.0004671017;
        // } else if(value == 16000000) {
        //   result = 12091;
        // } else if(value > 16000000) {
        //   result = 12091 + (value - 16000000) * 0.000311;
        // }

        // From Excel:
        // JOS(B6<100000; "350";
        // JOS(B6<250000; 350+(B6-100000)*0,004485;
        // JOS(B6<500000; 1023+(B6-250000)*0,002989;
        // JOS(B6<1000000; 1770+(B6-500000)*0,002241;
        // JOS(B6<2000000; 2891+(B6-1000000)*0,001495;
        // JOS(B6<4000000; 4385+(B6-2000000)*0,000924;
        // JOS(B6<16000000; 6233+(B6-4000000)*0,000449;
        // JOS(B6=16000000; "11622";
        // JOS(B6>16000000; 11622+(B6-16000000)*0,000299

        // Tests:
        // 60000 => 350
        // 150000 => 574
        // 275000 => 1098
        // 550000 => 1882
        // 1500000 => 3639
        // 2500000 => 4847
        // 4500000 => 6458
        // 16000000 => 11622
        // 17000000 => 11921

        // Year 2025-

        if(value < 100000) {
          result = 371;
        } else if(value < 250000) {
          result = 371 + (value - 100000) * 0.004759;
        } else if(value < 500000) {
          result = 1085 + (value - 250000) * 0.003171;
        } else if(value < 1000000) {
          result = 1878 + (value - 500000) * 0.002379;
        } else if(value < 2000000) {
          result = 3067 + (value - 1000000) * 0.001586;
        } else if(value < 4000000) {
          result = 4653 + (value - 2000000) * 0.000981;
        } else if(value < 16000000) {
          result = 6616 + (value - 4000000) * 0.0004760;
        } else if(value == 16000000) {
          result = 12332;
        } else if(value > 16000000) {
          result = 12332 + (value - 16000000) * 0.0003170;
        }

        // From Excel:
        // JOS(B6<100000; "371";
        // JOS(B6<250000; 371+(B6-100000)*0,004759;
        // JOS(B6<500000; 1085+(B6-250000)*0,003171;
        // JOS(B6<1000000; 1878+(B6-500000)*0,002379;
        // JOS(B6<2000000; 3067+(B6-1000000)*0,001586;
        // JOS(B6<4000000; 4653+(B6-2000000)*0,000981;
        // JOS(B6<16000000; 6616+(B6-4000000)*0,0004760;
        // JOS(B6=16000000; "12332";
        // JOS(B6>16000000; 12332+(B6-16000000)*0,0003170

        // Tests:
        // 60000 => 371
        // 150000 => 609
        // 275000 => 1164
        // 550000 => 1997
        // 1500000 => 3860
        // 2500000 => 5144
        // 4500000 => 6854
        // 16000000 => 12332
        // 17000000 => 12649

      }

      // Append € sign
      if(result >= 0) {
        result = Math.round(result);
        result += ' €';
      } else {
        result = '-';
      }

      $result.addClass('disappear');
      setTimeout(function(){
        $result.text(result);
        $result.removeClass('disappear');
      }, 150);
    }

    $btn.click(function(e){
      e.preventDefault();
      calculate_annual_fee();
    });

    $input.keypress(function(e) {
      if (e.which == 13) {
        calculate_annual_fee();
      }
    });

  };

})(jQuery);
